import React from "react";
import io from "socket.io-client";
import { useState } from "react";
import "./home.css";
import Chat from "../Chatfeed/chat";


const socket = io.connect("https://chat-app-rn95.onrender.com");

const Home = ({setLoginUser}) => {
  const[username, setUsername] = useState("");
  const[room, setRoom] = useState("");
  const[showChat, setShowChat] = useState(false);

  const joinRoom = () => {
   if (username !== "" && room !== "") {
     socket.emit("join_room", room);
     setShowChat(true);
   }
};

   return(
    <div className="homepage">
     <div className="button" onClick={() => setLoginUser({})} title="Logout"><i className="fa fa-power-off"></i></div>
     {!showChat ? (
        <div className="joinChatContainer">
          <h3>Join A Chat</h3>
          <input
            type="text"
            placeholder="Name.."
            onChange={(event) => {
              setUsername(event.target.value);
            }}
          />
          <input
            type="text"
            placeholder="Room ID..."
            onChange={(event) => {
              setRoom(event.target.value);
            }}
          />
          <button onClick={joinRoom}>Join A Room</button>
        </div>
      ) : (
        <Chat socket={socket} username={username} room={room} />
      )}
    </div>
   )
}
export default Home;